<script setup>
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore, useStoreGetters } from 'dashboard/composables/store';

import Spinner from 'next/spinner/Spinner.vue';
import ReportHeader from '../components/ReportHeader.vue';
import CampaignMetrics from './components/campaign/CampaignMetrics.vue';
import CampaignReportFilters from './components/campaign/CampaignReportFilters.vue';

const { t } = useI18n();
const store = useStore();
const getters = useStoreGetters();

const activeCampaign = ref(null);

const campaigns = getters['wgptCampaigns/getCampaigns'];
const uiFlags = getters['wgptCampaigns/getUIFlags'];

const isLoading = computed(() => uiFlags.value.isFetching);

const onFilterChange = campaign => {
  activeCampaign.value = campaign;
};

const fetchCampaigns = () => {
  store.dispatch('wgptCampaigns/get');
};

// Fetched once on open rather than from a watcher on `campaigns`: the list mutation assigns a brand
// new array on every fetch, so an account with no campaigns saw a changed-but-still-empty value,
// refetched, and span there forever behind the loader.
onMounted(() => {
  if (campaigns.value.length) return;

  fetchCampaigns();
});
</script>

<template>
  <ReportHeader :header-title="t('WGPT_CAMPAIGNS.REPORTS.TITLE')" />
  <div v-if="isLoading" class="flex justify-center my-4">
    <Spinner class="text-n-brand" />
  </div>
  <div
    v-else-if="campaigns.length === 0"
    class="h-48 flex items-center justify-center text-n-slate-12 text-sm"
  >
    {{ t('WGPT_CAMPAIGNS.REPORTS.EMPTY_STATE') }}
  </div>
  <div v-else class="flex flex-col flex-1 gap-4">
    <div class="flex">
      <CampaignReportFilters
        :campaigns="campaigns"
        @filter-change="onFilterChange"
      />
    </div>
    <CampaignMetrics v-if="activeCampaign" :campaign="activeCampaign" />
  </div>
</template>
